module.exports = __webpack_public_path__ + "img/80.426448b8.svg";